import React, { useContext } from "react";
import { Link as ScrollLink } from "react-scroll";
import { themeContext } from "../../../Context";
import { CLOUD_URL } from "../../../seo/seoConfig";
import "./HowWeStart.css";

const steps = [
  {
    title: "ابدأ من السحابة",
    desc: "سجّل وابدأ الاستخدام مجاناً عبر النظام السحابي، أو راسلنا لعرض مخصص.",
  },
  {
    title: "عرض حسب القطاع",
    desc: "نقدّم عرضاً يناسب نشاطك: وحدات أساسية أو نظام متخصص لقطاعك.",
  },
  {
    title: "تأسيس وتشغيل",
    desc: "نساعدك على الإعداد والتدريب حتى يعمل الفريق على النظام بثقة.",
  },
  {
    title: "ربط الفوترة الإلكترونية",
    desc: "نكمّل مسار الربط مع هيئة الزكاة والضريبة والجمارك ومنصة فاتورة عند الحاجة.",
  },
];

const HowWeStart = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="how-we-start" id="erp-how">
      <div className="erp-section-head">
        <h2 style={{ color: darkMode ? "white" : undefined }}>كيف نبدأ معك</h2>
        <p>
          ابدأ مجاناً من النظام السحابي، أو تواصل لعرض سعر حسب احتياج منشأتك.
        </p>
      </div>
      <div className="how-steps">
        {steps.map((step, index) => (
          <article className="how-step" key={step.title}>
            <span className="how-step-num">{String(index + 1).padStart(2, "0")}</span>
            <h3 style={{ color: darkMode ? "white" : undefined }}>{step.title}</h3>
            <p>{step.desc}</p>
          </article>
        ))}
      </div>
      <div className="how-actions">
        <a className="button how-btn" href={CLOUD_URL} target="_blank" rel="noopener noreferrer">
          ابدأ الاستخدام مجاناً
        </a>
        <ScrollLink to="contact" spy={true} smooth={true} offset={-40}>
          <button type="button" className="button how-btn how-btn-secondary">
            اطلب عرض سعر
          </button>
        </ScrollLink>
      </div>
    </section>
  );
};

export default HowWeStart;
